import {css} from '@emotion/css';
import {Breakpoints, mq} from '@fo/shared/styles/mixins';
import {colours, fonts, spacing, elementSize} from '@fo/shared/styles/variables';

const styles = {
  blogArticleHero: css`
    label: blogArticleHero;
    width: 100%;
    max-width: ${elementSize.container.XXL};
    margin: ${spacing.M} auto 0 auto;
  `,
  titleContainer: css`
    label: blogArticleHero__titleContainer;
    margin: ${spacing.L} auto ${spacing.M};
    padding-left: ${spacing.XXS};
    padding-right: ${spacing.XXS};

    ${mq(Breakpoints.TABLET)} {
      max-width: calc(${Breakpoints.DESKTOP}px + ${spacing.S} * 2);
      margin-top: 0;
      text-align: center;
    }
  `,
  categoryName: css`
    label: blogArticleHero__categoryName;
    color: ${colours.brand.SECONDARY};
    text-decoration: none;
  `,
  publicationDate: css`
    label: blogArticleHero__publicationDate;
    ${mq(Breakpoints.TABLET)} {
      margin-bottom: ${spacing.M};
    }
  `,
  shortDescription: css`
    label: blogArticleHero__shortDescription;
    color: ${colours.font.ASSISTIVE};
    ${mq(Breakpoints.TABLET)} {
      margin-bottom: ${spacing.M};
    }
  `,
  socialShare: css`
    label: blogArticleHero__socialShare;
    margin: 0;
    ${mq(Breakpoints.TABLET)} {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-bottom: ${spacing.M};
    }
  `,
  imageContainer: css`
    label: blogArticleHero__imageContainer;
    display: flex;
    text-align: center;
  `,
  heroImage: css`
    label: blogArticleHero__heroImage;
    width: 100%;
    height: 30rem;
    object-fit: cover;
    ${mq(Breakpoints.TABLET)} {
      height: 40rem;
    }
  `,
  heroImageSource: css`
    label: blogArticleHero__source;
    font-weight: ${fonts.weight.REGULAR};
    font-size: 1rem;
    text-align: center;
  `,
};

export default styles;
